export class MenuItem {
  constructor(public text: string, public link: string,
              public style?: string, public icon?: string) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/menu-item.ts